"use client";

import { useNavigationHistory } from "../../provider/NavigationProvider";
import { usePathname } from "next/navigation";
import { useRouter } from "nextjs-toploader/app";

const BackButton = () => {
  const pathname = usePathname();
  const router = useRouter();
  const historyStack = useNavigationHistory();

  return (
    <button
      onClick={() => {
        console.log(historyStack);

        // return;
        if (historyStack.length > 1) {
          //   historyStack.pop(); // Remove the current page
          //   const previousPage = historyStack[historyStack.length - 1];
          //   router.push(previousPage); // Go to the last in-app page

          router.back();
        } else {
          router.push("/"); // Redirect to the homepage
        }
      }}
      className={`${
        pathname === "/" ? "hidden" : "flex"
      } items-center gap-2 rounded-md p-1`}
    >
      <i className="fa-solid fa-arrow-left text-gray-700"></i>
      <span>Back</span>
    </button>
  );
};

export default BackButton;
